import { useQuery } from '@tanstack/react-query';
import * as api from '../api';
import { queryKeys } from '../state/queries';
import { setActiveMember, useActiveMemberId } from '../state/activeMember';
import { Avatar } from './ui';

/**
 * "Who's using this right now" — tap a monogram to author as that person. Tapping the
 * active one again clears it, which is what the shared wall tablet wants between users.
 */
export function MemberBar() {
  const activeId = useActiveMemberId();
  const { data: members = [] } = useQuery({ queryKey: queryKeys.members, queryFn: api.getMembers });

  if (members.length === 0) {
    return <p className="px-1 font-mono text-[12px] text-muted">Add family in Settings</p>;
  }

  return (
    <div>
      <p className="eyebrow mb-2 px-1">You are</p>
      <div className="flex flex-wrap gap-1.5">
        {members.map((m) => {
          const active = m.id === activeId;
          return (
            <button
              key={m.id}
              onClick={() => setActiveMember(active ? null : m.id)}
              aria-pressed={active}
              title={m.name}
              className="rounded-full"
            >
              <Avatar
                name={m.name}
                color={m.color}
                photoUrl={m.avatarUrl}
                size={34}
                ring={active}
                dimmed={activeId !== null && !active}
              />
            </button>
          );
        })}
      </div>
    </div>
  );
}
